import { useState, useMemo } from "react";
import { Container, Row, Col, Card, Button, Form, Tab, InputGroup } from "react-bootstrap";
import { t } from "i18next";

const PermissionsTabContent = ({ ports, selectedPorts, isEdit = false, togglePort, errors }) => {
    const [search, setSearch] = useState("");

    // Filtered ports based on search term
    const filteredPorts = useMemo(() => {
        if (!search) return ports;
        return ports?.filter((port) =>
            port.toLowerCase().includes(search.toLowerCase()) ||
            port.toString().includes(search)
        );
    }, [ports, search]);

    return (
        <Tab.Pane eventKey="permissions">
            <Card className="shadow-sm">
                <Card.Body>
                    <div className="mb-3">
                        <h5 className="mb-1">{t("assigned_access")}</h5>
                        <small className="text-muted">{t("assigned_ports_description")}</small>
                    </div>

                    {/*filteredPorts.length > 0 && <Form.Group className="mb-3">
                        <InputGroup>
                            <InputGroup.Text id="search-addon" style={{ backgroundColor: "#fff", borderRight: 0 }}>
                                🔍
                            </InputGroup.Text>
                            <Form.Control
                                placeholder={t("search_ports")}
                                aria-label="Search ports"
                                aria-describedby="search-addon"
                                value={search}
                                onChange={(e) => setSearch(e.target.value)}
                                style={{
                                    borderLeft: 0,
                                    borderRadius: "0.25rem",
                                    boxShadow: "none",
                                }}
                            />
                        </InputGroup>
                    </Form.Group>*/}
                    <Form.Group className="mb-3">
                        <InputGroup>
                            <InputGroup.Text id="search-addon" style={{ backgroundColor: "#fff", borderRight: 0 }}>
                                🔍
                            </InputGroup.Text>
                            <Form.Control
                                placeholder={t("search_ports")}
                                aria-label="Search ports"
                                aria-describedby="search-addon"
                                value={search}
                                onChange={(e) => setSearch(e.target.value)}
                                style={{
                                    borderLeft: 0,
                                    borderRadius: "0.25rem",
                                    boxShadow: "none",
                                }}
                            />
                        </InputGroup>
                    </Form.Group>
                    <Row>
                        {filteredPorts.length > 0 ? (
                            filteredPorts.map((port, index) => (
                                <Col md={6} lg={4} key={index} className="mb-3">
                                    <Card className="h-100 border-0 shadow-sm">
                                        <Card.Body className="d-flex align-items-center justify-content-between">
                                            <div>
                                                <div className="fw-semibold">{port}</div>
                                                <small className="text-muted">{t("port_code")}: {port}</small>
                                            </div>
                                            <Form.Check
                                                type="switch"
                                                checked={selectedPorts?.includes(port)}
                                                onChange={() => togglePort(port)}
                                            />
                                        </Card.Body>
                                    </Card>
                                </Col>
                            ))
                        ) : (
                            <Col>
                                <div className="text-muted text-center py-3">{t("no_ports_found")}</div>
                            </Col>
                        )}
                    </Row>
                </Card.Body>
            </Card>
        </Tab.Pane>
    );
};

export default PermissionsTabContent;
